import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeGuard } from './guards/home.guard';
import { IndexGuard } from './guards/index.guard';
import { MainGuard } from './guards/main.guard';
import { IpWhitelistGuard } from './guards/ip-whitelist.guard';
import { InitialRedirectGuard } from './guards/initial-redirect.guard';

const routes: Routes = [
  {
    path: 'home',
    canActivate: [HomeGuard, IpWhitelistGuard],
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
  },
  {
    path: '',
    canActivate: [InitialRedirectGuard],
    children: []
  },
  {
    path: 'login',
    canActivate: [IndexGuard, IpWhitelistGuard],
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'viewmycase',
    canActivate: [IndexGuard, IpWhitelistGuard],
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'main',
    canActivate: [MainGuard, IpWhitelistGuard],
    loadChildren: () => import('./master/master.module').then( m => m.MasterPageModule)
  },
  {
    path: 'otp-verification',
    canActivate: [IndexGuard, IpWhitelistGuard],
    loadChildren: () => import('./otp-verification/otp-verification.module').then(m => m.OtpVerificationPageModule)
  },
  {
    path: 'access-denied',
    loadChildren: () => import('./access-denied/access-denied.module').then( m => m.AccessDeniedPageModule)
  },
  {
    path: 'invoice/view/:caseid',
    loadChildren: () => import('./master/invoice-view/invoice-view.module').then(m => m.InvoiceViewModule)
  },
  {
    path: 'landing',
    canActivate: [IndexGuard],
    loadChildren: () => import('./landing/landing.module').then( m => m.LandingPageModule)
  },
  {
    path: 'quick-pay',
    loadChildren: () => import('./payments/quick-pay/quick-pay.module').then( m => m.QuickPayPageModule)
  },
  {
    path: 'payment-success',
    loadChildren: () => import('./payments/payment-success/payment-success.module').then( m => m.PaymentSuccessPageModule)
  },
  {
    path: 'application/view/:caseid',
    loadChildren: () => import('./master/invoice-view/invoice-view.module').then(m => m.InvoiceViewModule)
  },
  {
    path: 'credit-note-invoice/view/:caseid',
    loadChildren: () => import('./master/invoice-view/invoice-view.module').then(m => m.InvoiceViewModule)
  },
  {
    path: 'credit-note-application/view/:caseid',
    loadChildren: () => import('./master/invoice-view/invoice-view.module').then(m => m.InvoiceViewModule)
  },
  { path: '**', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
